module.exports = __webpack_public_path__ + "static/img/ios_kk.d6e247a2.png";